import inPutProductDialogReducer from './inPutProductDialogReducer';

export default inPutProductDialogReducer;